import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CampoModeloVistoria } from '../../../editar-modelo-vistoria/models/campo-modelo-vistoria';

@Component({
  selector: 'app-campos-modelo-vistoria',
  standalone: false,
  templateUrl: './campos-modelo-vistoria.component.html',
  styleUrl: './campos-modelo-vistoria.component.scss'
})
export class CamposModeloVistoriaComponent {

  @Input() campos: CampoModeloVistoria[] = [];
  @Output() camposChange = new EventEmitter<CampoModeloVistoria[]>();

  public adicionar(): void {
    this.campos.push({ id: 0, nome: '', tagHtmlPdf: null, valorPadrao: null });
    this.emitir();
  }

  public remover(campo: CampoModeloVistoria): void {
    this.campos = this.campos.filter(c => c !== campo);
    this.emitir();
  }

  private emitir(): void {
    this.camposChange.emit(this.campos);
  }
}
